import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import WhatsappSettingsLayer from "../components/WhatsappSettingsLayer";

const WhatsappSettingsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Whatsapp Settings" />

        {/* WhatsappSettingsLayer */}
        <WhatsappSettingsLayer />

      </MasterLayout>
    </>
  );
};

export default WhatsappSettingsPage;

